<!-- =========================================================================================
    File Name: Bills.vue
    Description: Displays the list of user's company bills
========================================================================================== -->
<template>
    <div class="bills">
        <!-- <column-layout> -->
        <div class="flex flex-wrap justify-between items-start mb-8">
            <h2 class="font-light text-lg my-3">LISTE DE VOS FACTURES</h2>
            <div class="flex">
                <!-- <vs-button :to="{path: '/' }" type="gradient" icon-pack="feather" icon="icon-chevron-left" class="mr-2">
                  Retour
                </vs-button> -->
                <!-- <vs-button :to="{ name: 'Editer une facture', params: { id: -1 }}" type="gradient" color="success" icon-pack="feather" icon="icon-plus">
                  Ajouter une facture
                </vs-button> -->
            </div>
        </div>

        <vs-card class="px-2">

            <h3 class="h5 uppercase mb-5">Filtrer par: </h3>
            <form ref="form" @submit.prevent class="filter__bills flex gap-4 flex-wrap mb-4">
                <div class="filter__bills-client">
                    <p class="label">Client</p>
                    <vs-select
                        v-model="client"
                        @change="onChange()"
                        class="select__client"
                    >
                        <vs-select-item :key="index" :value="item" :text="item"
                                        v-for="(item, index) in billsClientName"/>
                    </vs-select>
                </div>

                <div class="filter__bills-statut">
                    <p class="label">Statut</p>
                    <vs-select
                        v-model="statusFilter"
                        @change="onChange()"
                        class="select__status"
                    >
                        <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in billsStatus"/>
                    </vs-select>
                </div>


                <div class="filter__bills-price flex flex-wrap">
                    <p class="label">Montant</p>
                    <div class="filter__price-input">
                        <input type="number" name="min" id="min" :min="billsAmountMin" :max="billsAmountMax"
                               @change="onChange()" placeholder="Montant minimum" class="filter__price-min">
                    </div>

                    <div class="filter__price-input">
                        <input type="number" name="max" id="max" :min="billsAmountMin" :max="billsAmountMax"
                               @change="onChange()" placeholder="Montant maximum" class="filter__price-max">
                    </div>
                </div>
            </form>

            <vs-table id="bills-view" search stripe max-items="10" pagination :data="billsData"
                      v-if="billsData && billsData.length">
                <template slot="header">
                    <h3 class="h5 uppercase">
                        Vos Factures
                    </h3>
                </template>
                <template slot="thead">
                    <vs-th style="width:20px">&nbsp;</vs-th>
                    <vs-th sort-key="number">Facture</vs-th>
                    <vs-th sort-key="destinataire.name">Client</vs-th>
                    <vs-th sort-key="emission_date">Date émission</vs-th>
                    <vs-th sort-key="due_date">Date échéance</vs-th>
                    <vs-th sort-key="amount_ttc" class="montant">Montant</vs-th>
                    <vs-th sort-key="status.name">Statut</vs-th>
                    <!-- <th @click="filterStatusArrows">Statut</th> -->
                    <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="index" v-for="(file, index) in data">
                        <vs-td>
                            <div class="w-12 h-12 pt-1 text-xl align-center justify-center inline-flex rounded-full"
                                 :class="`text-${ currentBillStatus(file.status.code).color }`"
                                 :style="{background: `rgba(var(--vs-${ currentBillStatus(file.status.code).color }),.15)`}">
                                <i class="m-auto leading-normal fal fa-lg fa-fw fa-file-invoice"/>
                            </div>
                        </vs-td>

                        <vs-td :data="file.number">
                            <!-- <span class="text-muted">Facture</span><br> -->
                            N°{{ file.number }}
                        </vs-td>

                        <vs-td :data="file.destinataire">
                            <template v-if="file.destinataire">
                                {{ file.destinataire.name }}
                            </template>
                            <!-- <span class="text-muted">Client</span><br> -->
                        </vs-td>
                        <vs-td :data="data[index].emission_date">
                            <!-- <span class="text-muted">Date émission</span><br> -->
                            <template v-if="data[index].emission_date">
                                {{ data[index].emission_date | moment('DD/MM/YYYY') }}
                            </template>
                        </vs-td>

                        <vs-td :data="file.due_date">
                            <!-- <span class="text-muted">Date échéance</span><br> -->
                            <template v-if="file.due_date">
                                {{ file.due_date | moment('DD/MM/YYYY') }}
                            </template>
                        </vs-td>

                        <vs-td :data="file.amount_ttc" class="text-right">
                            <span class="text-success text-nowrap">{{
                                    Number(file.amount_ttc) | numFormat('$ 0,0.00')
                                }}</span>&nbsp;<span class="text-muted">/</span> &nbsp;<span
                            class="text-danger text-nowrap">{{
                                Number(data[index].total_paid) | numFormat('$ 0,0.00')
                            }}</span>
                        </vs-td>

                        <vs-td :data="file.status.name">
                            <vs-chip :color="currentBillStatus(file.status.code).color"
                                     style="white-space: nowrap;">
                                <strong>{{ file.status.name }}</strong>
                            </vs-chip>
                        </vs-td>

                        <vs-td :data="file.id" style="width: 260px;" class="px-3">
                            <div class="flex">
                                <vs-button class="mr-2" type="border" color="primary"
                                           :to="{ name: 'Editer une facture', params: { id: file.id }}">Afficher
                                </vs-button>
                                <vs-button
                                    @click="doModalPaiement(file.id, file.client.name,file.number)"
                                    size="large" class="leading-none px-6 py-3 text-sm" icon-pack="far"
                                    icon="fa-wallet mr-3" type="gradient" color="primary">Enregistrer<br>paiement(s)
                                </vs-button>
                            </div>
                        </vs-td>

                    </vs-tr>
                </template>

            </vs-table>
            <empty-card v-else/>
        </vs-card>


        <!--  ASIDE -->
        <!-- <template slot="aside">

          <h2 class="font-light text-lg mt-20 mb-4">AIDE :</h2>
          <div class="text-sm md:pr-4">
            <p class="mb-8">Eodem tempore Serenianus ex duce, cuius ignavia populatam in Phoenice Celsen ante rettulimus, pulsatae maiestatis imperii reus iure postulatus ac lege, incertum qua potuit suffragatione absolvi, aperte convictus familiarem suum cum pileo, quo caput operiebat, incantato vetitis artibus ad templum misisse fatidicum, quaeritatum expresse an ei firmum portenderetur imperium, ut cupiebat, et cunctum.</p>
          </div>
        </template> -->

        <!-- </column-layout> -->

        <vs-prompt
            title="Enregistrer un nouveau règlement"
            @cancel="clearPaiementForm"
            @accept="acceptPaiementForm"
            accept-text="Valider"
            cancel-text="Annuler"
            :is-valid="validPaiement"
            :active.sync="activeModalPaiement">
            <div class="payment-form">

                <i class="far fa-info-circle mr-2"></i>Veuillez saisir les informations de règlement ci-dessous, pour la
                facture N° <span class="text-primary">{{ formPaiement.number }}</span>, nom du client : <span
                class="text-primary">{{ formPaiement.clientName }}</span>.

                <vs-input
                    type="number"
                    label="Montant"
                    v-model.number="formPaiement.montant"
                    class="mt-4 mb-2 w-full"
                    :danger="!Boolean(formPaiement.montant)"
                    danger-text="Vous devez indiquer un montant"
                    placeholder="montant en €"
                    val-icon-pack="feather"
                    val-icon-danger="icon-x"/>

                <div class="vs-component vs-con-input-label vs-input mt-4 mb-2 w-full vs-input-primary">
                    <label class="vs-input--label" for="dateReglement"><i class="far fa-calendar mr-1"></i> Date du
                        règlement</label>
                    <datepicker monday-first :language="fr" v-model="formPaiement.date" :value="formPaiement.date"
                                id="dateReglement" class="mt-1" :disabled-dates="{from: new Date() }"
                                placeholder="Sélectionnez une date" format="dd/MM/yyyy"></datepicker>
                </div>

                <vs-alert :active="!Boolean(formPaiement.date)" color="danger">
                    Vous devez indiquer une date de règlement
                </vs-alert>
            </div>
        </vs-prompt>
    </div>
</template>

<script>
// @ is an alias to /src

import ColumnLayout from '@/layouts/columns/ColumnLayout.vue'
import {fr} from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'

import billMixins from '@/mixins/billMixins'
import {mapState, mapActions, mapGetters} from 'vuex'
import axios from '@/axios.js'

export default {
    name: 'Bills',
    mixins: [billMixins],
    components: {
        ColumnLayout,
        Datepicker
    },
    data() {
        return {
            fr,
            activeModalPaiement: false,
            client: '',
            statusFilter: '',
            billsData: [],
            billsDataForStatus: [],
            billsClientName: [''],
            billsStatus: [''],
            billsAmount: [],
            billsAmountMin: '',
            billsAmountMax: '',
            count: 1,
            formPaiement: {
                clientName: '',
                number: null,
                id: null,
                montant: '',
                date: ''
            }
        }
    },
    computed: {
        ...mapState({
            bill: state => state.bill.bill,
            bills: state => state.bill.bills,
            billsLoading: state => state.bill.billsLoading
        }),
        ...mapGetters({
            billsOrderByemission_date: 'bill/billsOrderByDateEmission'
        }),
        total: {
            get() {
                return this.$store.state.bill.total
            },
            set(val) {
                this.$store.state.bill.total = val
            }
        },
        validPaiement() {
            return Boolean(this.formPaiement.id) && Boolean(this.formPaiement.montant) && this.formPaiement.date !== ''
        }
    },
    beforeRouteUpdate(to, from, next) {
        if (to.name === 'Factures') {
            this.$vs.loading()
            this.getAllBills({
                page: 1,
                limit: 100000
            }).then(() => {
                next()
                this.$vs.loading.close()
            }).catch(() => {
                this.$vs.loading.close()
                next()
            })
        } else {
            next()
        }
    },
    created() {
        this.refreshList()
    },
    methods: {
        ...mapActions('bill', ['getAllBills', 'deleteBill', 'getBill', 'addReglementToBill']),

        refreshList() {
            this.$vs.loading()
            this.getAllBills({
                page: 1,
                limit: 100000
            }).then(() => {
                this.$vs.loading.close()
            }).then(() => {
                this.billsData = this.$store.state.bill.bills
                this.getClientSelector()
                this.getStatutSelector()
                this.getAmountSelector()
            }).catch(() => {
                this.$vs.loading.close()
            })
        },
        deleteItem(id) {
            this.deleteBill(id).then(() => {
                this.refreshList()
            })
        },

        getClientSelector() {
            this.$store.state.bill.bills.forEach(item => {
                if (item.destinataire) {
                    this.billsClientName.push(item.destinataire.name)
                }
            })

            this.billsClientName = [...new Set(this.billsClientName)].sort()
        },

        getStatutSelector() {
            this.$store.state.bill.bills.forEach(item => {
                this.billsStatus.push(item.status.name)
            })

            this.billsStatus = [...new Set(this.billsStatus)]
        },

        getAmountSelector() {
            this.$store.state.bill.bills.forEach(item => {
                this.billsAmount.push(item.amount_ttc)
            })

            this.billsAmount = [...new Set(this.billsAmount)]

            this.billsAmountMin = Math.min.apply(Math, this.billsAmount)
            this.billsAmountMax = Math.max.apply(Math, this.billsAmount)
        },

        onChange() {
            this.billsData = this.$store.state.bill.bills
            const selectors = [{
                sel: '.select__client .input-select',
                type: 'Client'
            }, {sel: '.select__status .input-select', type: 'Status'}, {
                sel: '.filter__price-input .filter__price-min',
                type: 'Amount'
            }, {sel: '.filter__price-input .filter__price-max', type: 'Amount'}]

            selectors.forEach(sel => {
                if (this.$refs.form.querySelector(sel.sel).value !== '') {
                    this.billsData = this.filterInvoice(sel.type)
                }
            })
        },

        filterInvoice(name) {
            switch (name) {
                case 'Client':
                    return this.filterClient()
                case 'Status':
                    return this.filterStatus()
                case 'Amount':
                    return this.filterAmount()
                default:
                    return this.billsData
            }
        },

        filterClient() {
            return this.billsData.filter((el) => {
                if (!el.destinataire) {
                    return false
                }
                return el.destinataire.name === this.$refs.form.querySelector('.select__client .input-select').value
            })
        },

        filterStatus() {
            return this.billsData.filter((el) => {
                return el.status.name === this.$refs.form.querySelector('.select__status .input-select').value
            })
        },

        filterAmount() {
            let minField = document.querySelector('.filter__bills-price .filter__price-input .filter__price-min').value
            let maxField = document.querySelector('.filter__bills-price .filter__price-input .filter__price-max').value

            minField = minField === '' ? this.billsAmountMin : minField
            maxField = maxField === '' ? this.billsAmountMax : maxField

            return this.billsData.filter((el) => {
                return el.amount_ttc >= minField && el.amount_ttc <= maxField
            })
        },
        doModalPaiement(id, client, number) {
            this.formPaiement.clientName = client
            this.formPaiement.id = id
            this.formPaiement.number = number
            this.activeModalPaiement = true
        },

        clearPaiementForm() {
            this.formPaiement.clientName = ''
            this.formPaiement.id = null
            this.formPaiement.number = null
            this.formPaiement.montant = ''
            this.formPaiement.date = ''
        },

        acceptPaiementForm() {
            this.getBill(this.formPaiement.id).then(() => {

                this.addReglementToBill(
                    {
                        id: this.formPaiement.id,
                        reglement: {
                            date: this.formPaiement.date,
                            amount: this.formPaiement.montant
                        }
                    }
                ).then(() => {
                    this.clearPaiementForm()
                    this.refreshList()
                })
            })
        }
    }
}
</script>

<style lang="scss">

#icon-col {
    width: 10rem;
}

#bills-view {
    th.montant .vs-table-text {
        justify-content: flex-end !important;
        text-align: right;
    }
}

.filter__bills {
    &-price {
        column-gap: 10px;

        p.label {
            flex: 100%;
        }

        input {
            display: block;
            padding: 10px;
            font-size: 1rem;
            border: 1px solid rgba(0, 0, 0, 0.2);
            border-radius: 5px;
            width: 100%;
            min-width: 150px;

            &::placeholder {
                font-size: .85rem;
                color: rgba(0, 0, 0, .6);
            }
        }

        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        input[type=number] {
            -moz-appearance: textfield;
        }
    }
}
</style>
